module.exports = __webpack_public_path__ + "static/img/background.857de8b9.svg";